/* eslint-disable no-underscore-dangle */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/system';
import GET_HOME from '../../query/home';
import Layout from '../../layout';
import { useFetchGraphQL } from '../../hooks';
import KeyBenefit from './KeyBenefit/KeyBenefit';
import './home.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import MobileApplication from './MobileApplication/MobileApplication';
import FarmsVet from './FarmsVet/FarmsVet';
import SuccessStories from './SuccessStory/SuccessStories';
import ScheduleAppointment from './ScheduleAppointment/ScheduleAppointment';
import Hero from './Hero/Hero';
import Growth from './Growth/Growth';
import PageLoader from '../../components/PageLoader/PageLoader';

function Home() {
  const { loading, error, data: landing } = useFetchGraphQL(GET_HOME);
  const [headerAction, setHeaderAction] = useState(null);

  // Function to handle header button clicks
  const handleHeaderAction = (action) => {
    setHeaderAction(action);
  };

  // Reset headerAction after it's been processed
  useEffect(() => {
    if (headerAction) {
      // Set a timeout to reset the headerAction after it's been processed
      const timer = setTimeout(() => {
        setHeaderAction(null);
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [headerAction]);

  if (loading) return <PageLoader />;
  if (error) return <p>Error! {error.message}</p>;

  // Validate if landing and landingPage exist
  if (!landing?.landingPage?.blocks) {
    console.error('Landing page data is missing');
    return <p>Error loading page content</p>;
  }

  // Validation helper functions
  const isValidSection = (section) => section && Object.keys(section).length > 0;
  const isValidArray = (arr) => Array.isArray(arr) && arr.length > 0;

  // Render a section based on its type
  const renderSection = (block) => {
    // eslint-disable-next-line no-underscore-dangle
    const blockType = block.__typename;

    switch (blockType) {
      case 'ComponentLandingHeroLandingHero':
        return isValidSection(block) && (
          <Hero
            heroSection={block}
            headerAction={headerAction}
          />
        );
      case 'ComponentKeyBenefitsSectionKeyBenefitsSection':
        return isValidSection(block) && isValidArray(block?.tabs) && (
          <KeyBenefit keyBenefits={block} />
        );
      case 'ComponentDownloadApplicationDownloadApplication':
        return isValidSection(block) && (
          <MobileApplication downloadApplication={block} />
        );
      case 'ComponentFarmsVetSectionFarmsVetSection':
        return isValidSection(block) && (
          <FarmsVet farmsVetSection={block} />
        );
      case 'ComponentGrowthSectionGrowthSection':
        return isValidSection(block) && (
          <Growth growthSection={block} />
        );
      case 'ComponentSuccessStoriesSuccessStories':
        return isValidSection(block) && (
          <SuccessStories successStories={block} />
        );
      case 'ComponentScheduleSectionScheduleSection':
        return isValidSection(block) && (
          <ScheduleAppointment scheduleData={block} />
        );
      default:
        return null;
    }
  };

  return (
    <Layout onHeaderAction={handleHeaderAction}>
      <Grid className="home-wrap">
        {/* Render sections in the order they appear in the GraphQL response */}
        {landing?.landingPage?.blocks?.map((block, index) => (
          <React.Fragment key={`block-${index}`}>
            {renderSection(block)}
          </React.Fragment>
        ))}
      </Grid>
    </Layout>
  );
}

export default Home;
